import React, { useState } from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FuseInput } from '/src/components';
import { useUserStore } from '/src/context';
import { DesktopLayout } from '/src/layouts';

/**
 * Forgot Password Page
 */
export const ForgotPasswordPage: React.FC = observer(() => {
  /** Computed **/
  const userStore = useUserStore();

  /** State **/
  const [username, setUsername] = useState<string>();
  const [error, setError] = useState<string>();
  const [success, setSuccess] = useState<string>();

  /** Methods **/

  /**
   * Requests that a password reset token be sent to the User's email address.
   */
  const askForPasswordReset = async () => {
    if (!username) return;

    setSuccess(undefined);
    setError(undefined);

    try {
      const response = await userStore.askForPasswordReset(username);

      setSuccess(response.message);
    } catch (err: unknown) {
      setError((err as Error).message);
    } finally {
      setUsername('');
    }
  };

  /** Render **/
  return (
    <DesktopLayout>
      <Box className="row">
        <h3 className="col-md-12 text-center">Restore your password</h3>
        <p className="small text-center">Enter your account username.</p>
        <Box component="div" className="col-xs-offset-2 col-xs-8 col-md-offset-5 col-md-2">
          <Box component="fieldset">
            <FuseInput
              label="Username"
              type="text"
              id="username"
              value={username}
              updateValue={(value) => setUsername(value)}
            />

            <Box component="div" className="text-center form-group">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={() => askForPasswordReset()}
                disabled={!username}
              >
                Submit
              </button>
            </Box>
            {error && (
              <Box component="div" className="text-center text-danger">
                <strong>{error}</strong>
              </Box>
            )}
            {success && (
              <Box component="div" className="text-center text-success">
                <strong>{success}</strong>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </DesktopLayout>
  );
});
